export enum InboxType {
  ALL = 'All',
  REPORT_ISSUE = 'Report issues',
  BIKE = 'Bikes',
}
